module.exports = __webpack_public_path__ + "static/media/UP-TURN2.687ee4f7.webp";